import { cachingService, LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import {
  API_HOST_COMMS,
  API_HOST_REFDATA,
  API_HOST_USERS,
  API_HOST_SVR,
  API_HOST_SEARCH,
  API_HOST_ORGS,
} from "../config";
import { AwardingOrgSearchService } from "./AwardingOrgSearchService";
import { AwardingOrgService } from "./AwardingOrgService";

import { InformationRequestService } from "./InformationRequestService";

import { ResourceTagsService } from "./ResourceTagsService";
import { TagsService } from "./TagsService";
import { UserService } from "./UserService";
import { CAOActionTypeService, CAORequestTypeService, CAORequestSubTypeService } from "./CAORefDataService";
import caoStatuses from "./json/caoStatuses.json";

export const informationRequestService = new InformationRequestService(
  API_HOST_COMMS
);
export const resourceTagsService = new ResourceTagsService(API_HOST_SVR);

export const tagsService = new TagsService(API_HOST_REFDATA);
export const usersService = new UserService(API_HOST_USERS);

export const requestTypeLookupService = new CAORequestTypeService(API_HOST_REFDATA);
export const cachedRequestTypeLookupService = cachingService(
  requestTypeLookupService
);

export const actionTypesService = new CAOActionTypeService(API_HOST_REFDATA);
export const cachedActionTypesService = cachingService(
  actionTypesService
);

export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);
export const aoService = new AwardingOrgService(API_HOST_ORGS);
export const cachingAoService = cachingService(aoService);

export const requestSubTypeLookupService = new CAORequestSubTypeService(API_HOST_REFDATA);
export const cachedRequestSubTypeLookupService = cachingService(
  requestSubTypeLookupService
);


export const caoStatusService = new LocalLookupService(caoStatuses);
